import React from 'react';
import styled from '@emotion/styled';
import { Box } from 'localmed-core';
import tinycolor from 'tinycolor2';
import { css } from '@emotion/core';

import Spinner from '../../../scheduling/assets/Spinner.gif';

const AnimationWrapper = styled('div')(
  `
  text-align: center;
`
);
const Image = styled('img')`
  height: 200px;
`;

const OverlayWrapper = styled(Box)(
  ({ theme }: any) => css`
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${tinycolor(theme.colors.white).setAlpha(0.8).toString()};
    z-index: ${theme.zIndices.modalOverlay};
  `
);

export default function SchedulingLoading() {
  return (
    <AnimationWrapper>
      <Image src={Spinner} alt="Di Spinner animation" />
    </AnimationWrapper>
  );
}

export function LoadingOverlay() {
  return (
    <OverlayWrapper>
      <SchedulingLoading />
    </OverlayWrapper>
  );
}
